import { useTranslation } from "react-i18next"

import { CrewStatTile } from "@/components/crew/crew-stat-tile"

/**
 * OKS-49 — Rank stat tile on the brand-side creator detail page
 * (UX Spec §2.3 — sibling of the OKS-48 "XP earned" tile).
 *
 * Composes `<CrewStatTile>` so the rank tile and XP tile share the
 * same visual shape + accessibility wiring. The rank `name` lands in
 * the `value` slot (intentionally NOT a number — `CrewStatTile`'s
 * `tabular-nums` font hint is harmless for short strings; the value
 * never wraps because rank names are ≤16 chars in v1).
 *
 * Locked testid: `crew-rank-tile` (mirrors the `crew-list-stat-xp`
 * pattern; QA matrix asserts both tiles render side-by-side).
 */
interface CrewRankTileProps {
  name: string
  className?: string
}

export function CrewRankTile({ name, className }: CrewRankTileProps) {
  const { t } = useTranslation()

  return (
    <CrewStatTile
      testId="crew-rank-tile"
      label={t("rank.tile.label")}
      value={name}
      rawValue={name}
      className={className}
    />
  )
}
